export default __webpack_public_path__ + "static/media/kilncare.74a059e7.jpg";